const rooster = {
  helpIconContainer: {
    position: 'relative',
    zIndex: '635',
  },
}

const tops = {
  helpIconContainer: {
    display: 'inline-flex',
    width: '100%',
    height: '40px',
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  tops :
  rooster



// WEBPACK FOOTER //
// ./src/components/Settings/styles/HelpButton.js